import React, {useState, useEffect} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress, Typography} from "@mui/material";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import CustomTextField from "../../../core/components/ui/CustomTextFieldV2";
import useWorkspaceManagement from "../hooks/useWorkspaceManagement";
import useWorkspaceStore from "../zustand/useUpdateWorkspaceStore";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";

const EditWorkspaceComponent = ({open, setOpen, workspaceId}) => {

    const {workspaceDetails, isEditingWorkspace, viewWorkspace, editWorkspace} = useWorkspaceManagement();
    const {isWorkspaceUpdated, setWorkspaceUpdated} = useWorkspaceStore();

    const [temporaryFields, setTemporaryFields] = useState({name: "", description: ""});
    const [isFormValid, setIsFormValid] = useState(false);
    const [activeField, setActiveField] = useState(null);
    
    const nameCharacterLimit = 50;
    const descriptionCharacterLimit = 120;


    useEffect(() => {
        let parameters = {
            id: workspaceId
        }

        viewWorkspace(parameters);
    }, [workspaceId])

    useEffect(() => {
        if (workspaceDetails) {
            setTemporaryFields({
                name: workspaceDetails?.name,
                description: workspaceDetails?.description
            });
        }
    }, [workspaceDetails]);

    useEffect(() => {
        validateForm();
    }, [temporaryFields?.name, temporaryFields?.description]);

    useEffect(() => {
        if (isWorkspaceUpdated) {
            handleClose(); 
        }
    }, [isWorkspaceUpdated])
    

    const validateForm = () => {
        const {name, description} = temporaryFields;
        const isValid = name?.trim() !== "" && description?.trim() !== "";

        setIsFormValid(isValid);
    }
    
    const handleTextfieldChange = (key) => (e) => {
        setTemporaryFields(prev => {
            return {
                ...prev,
                [key]: e.target.value
            }
        })
    }

    const handleFocus = (field) => () => {
        setActiveField(field);
    }

    const handleBlur = () => {
        setActiveField(null);
    }
    
    
    const handleClose = () => {
        setOpen(false);
        setTemporaryFields({name: "", description: ""});
    }

    const handleEditWorkspace = async (e) => {
        if (isFormValid) {
            let payload = {
                "name": temporaryFields?.name,
                "description": temporaryFields?.description,
                "id": workspaceId
            }
    
            editWorkspace(payload);  
            setWorkspaceUpdated(false);
        }
    }

    const actions = [
        {
            label: "Update",
            onClick: (e) => {
                handleEditWorkspace(e);
            },
        }
    ]


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isEditingWorkspace) ? null : handleClose}
                title="Edit Workspace"
                content={
                    <Box>
                        {(isEditingWorkspace) ? 
                            <CustomDialogLoaderComponent 
                                icon={<CircularProgress size={40} sx={{color: "#604CC3"}} />} 
                                message="Updating..." 
                            />
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle1" 
                                    text={"Name"} 
                                    customStyles={{marginBottom: 0, fontWeight: 400, color: "#58565F", fontSize: 18}}
                                />

                                <CustomTextField 
                                    placeholder={"Name"}
                                    variant={"filled"}
                                    onChange={handleTextfieldChange("name")}
                                    value={temporaryFields?.name}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                    inputProps={{maxLength: nameCharacterLimit}}
                                    onFocus={handleFocus("name")}
                                    onBlur={handleBlur}
                                />

                                {activeField === "name" && 
                                    (<Typography align="right" sx={{color: (temporaryFields?.name?.length === nameCharacterLimit) ? "red" : "#58565f", fontSize: 12, mt: "5px"}}>
                                        {temporaryFields?.name?.length}/{nameCharacterLimit}
                                    </Typography>)
                                }
                                
                                {(activeField === "name") ? <></> : <><br /> <br /></>}

                                <CustomTypography 
                                    variant="subtitle1" 
                                    text={"Description"} 
                                    customStyles={{marginBottom: 0, fontWeight: 400, color: "#58565F", fontSize: 18}}
                                />

                                <CustomTextField 
                                    placeholder={"Description"}
                                    variant={"filled"}
                                    onChange={handleTextfieldChange("description")}
                                    value={temporaryFields?.description}
                                    fullWidth={true}
                                    rows={3}
                                    multiline={true}
                                    hiddenLabel
                                    inputProps={{maxLength: descriptionCharacterLimit}}
                                    onFocus={handleFocus("description")}
                                    onBlur={handleBlur}
                                />
                                {activeField === "description" && 
                                    (<Typography align="right" sx={{color: (temporaryFields?.description?.length === descriptionCharacterLimit) ? "red" : "#58565f", fontSize: 12, mt: "5px"}}>
                                        {temporaryFields?.description?.length}/{descriptionCharacterLimit}
                                    </Typography>)
                                }
                            </>
                        }
                    </Box>
                }
                actions={!isEditingWorkspace && actions}
                maxWidth={"sm"}
                customStyles={{
                    actions: {
                        opacity: (isFormValid && !isEditingWorkspace) ? "100%" : "55%",
                        cursor: (isFormValid && !isEditingWorkspace) ? "pointer" : "not-allowed",
                        visibility: (isEditingWorkspace) ? "hidden" : "visible",
                    }
                }}
                globalSx={{}}
            />  
        </>
    )
}

export default EditWorkspaceComponent